import { put, takeLatest } from "redux-saga/effects";
import { Routes } from "../../constants/routes";
import Client from "../../services/Client";
import { loadClinicInformation } from "../../store/ClinicInformation/actions";
import { disconnectKeyboard } from "../../store/Keyboard/actions";
import {
    authenticateUser,
    changeLoginInformationAlreadySubmissionState,
    toggleMyleCommunicationIssuesState,
    toggleValidLoginStatus
} from "../../store/Login/actions";
import {
    GET_CLINIC_INFORMATION_REQUEST,
    POST_LOGIN_INFORMATION,
    POST_SURVEY_RESULT
} from "./constant";
import {
    PostLoginInformationToServerAction,
    PostSurveyResultToServerAction
} from "./types";
import { toggleNetworkLoadingSpinnerVisibility } from "../../store/LoadingSpinner/actions";
import { loadLanguageServiceFromServer } from "../../store/LanguageLocale/actions";
import { errorHandlerSaga } from "../errorSaga";
import { toggleSurveySentStatus } from "../../store/Survey/actions";
import { push } from "../../store/Routing/actions";
import { debugDispatchSaga } from "../debugDispatchSaga";


export function* GetClinicInformationRequestSaga() {
    try {
        const resp = yield Client.getClinicInformation();
        yield put(loadClinicInformation(resp));
        yield put(loadLanguageServiceFromServer(resp.languageResourceServiceDto))
    } catch (e) {
        yield errorHandlerSaga(e);
    }
}

export function* PostLoginInformationRequestSaga(action: PostLoginInformationToServerAction) {
    yield put(toggleValidLoginStatus(true));
    yield put(changeLoginInformationAlreadySubmissionState(true));
    yield put(toggleNetworkLoadingSpinnerVisibility(true));
    yield put(disconnectKeyboard());
    try {
        yield Client.postLoginInformation(action.payload.userName, action.payload.password, action.payload.authenticationCode);
        yield debugDispatchSaga("Login Successful", false);
        yield GetClinicInformationRequestSaga();
        yield debugDispatchSaga("Get Clinic Information Successful", false);
        yield put(toggleNetworkLoadingSpinnerVisibility(false));
        yield put(changeLoginInformationAlreadySubmissionState(false));
        yield put(toggleMyleCommunicationIssuesState(false));
        yield put(push(Routes.adminSetup));
        yield put(authenticateUser(true));
        yield debugDispatchSaga("Navigate to admin page successful", false);
    } catch (err) {
        yield debugDispatchSaga("Encounterred Error", true, err);
        if (err.responseStatus.errorCode === "Unauthorized") {
            yield put(toggleValidLoginStatus(false));
        } else {
            yield put(toggleMyleCommunicationIssuesState(true));
        }
        yield put(changeLoginInformationAlreadySubmissionState(false));
        yield put(toggleNetworkLoadingSpinnerVisibility(false));
    }
}

export function* postSurveyResultSaga(action: PostSurveyResultToServerAction) {
    try {
        yield put(toggleNetworkLoadingSpinnerVisibility(true));
        yield Client.postSurveyResult(action);
        yield put(toggleSurveySentStatus(true));
    } catch (e) {
        yield errorHandlerSaga(e);
    }
    yield put(toggleNetworkLoadingSpinnerVisibility(false));
}

export function* watchForAllRequestSagas() {
    yield takeLatest(POST_LOGIN_INFORMATION, PostLoginInformationRequestSaga);
    yield takeLatest(GET_CLINIC_INFORMATION_REQUEST, GetClinicInformationRequestSaga);
    yield takeLatest(POST_SURVEY_RESULT, postSurveyResultSaga);
}


// WEBPACK FOOTER //
// ./src/sagas/RequestSagas/sagas.ts